
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class QuotaTimeSelect extends Vue {
  @Prop({ required: true }) readonly value!: number | null;
  @Prop({ default: false }) disabled: boolean;

  get selectedQuotaTime(): number | null {
    return this.value;
  }

  set selectedQuotaTime(val: number | null) {
    this.$emit("input", val);
  }

  get quotaTimes() {
    return [
      { text: this.$i18n.translate("transportationPermission.quotaTimes.month", "Month"), value: 0 },
      { text: this.$i18n.translate( "transportationPermission.quotaTimes.day", "Day"), value: 1 },
      { text: this.$i18n.translate( "transportationPermission.quotaTimes.week", "Week" ), value: 2 },
      { text: this.$i18n.translate( "transportationPermission.quotaTimes.year", "Year" ), value: 3 },
      { text: this.$i18n.translate( "transportationPermission.quotaTimes.fourMonths", "Four months" ), value: 4 },
      { text: this.$i18n.translate( "transportationPermission.quotaTimes.threeMonths", "Three months" ), value: 5 },
    ];
  }
}
